<template>
  <div :class="{'survey-field': true, ['survey-field-'+field.name]: true}">
    <h4>
      <div class="survey-field-highlight"></div>
      {{ field.title }}
    </h4>
    <div
      :class="{
        'survey-component': true,
        ['survey-component-'+field.type]: true,
        ['survey-component-columns-'+(field.columns || 'default')]: true
      }"
    >
      <template v-if="field.type == 'select'">
        <select v-model="newValue">
          <option value disabled selected>{{ $t("בחר...") }}</option>
          <option
            v-for="(option, key) in options(field.options)"
            :key="key"
            :value="key"
          >{{ option }}</option>
        </select>
      </template>
      <template v-else-if="field.type == 'radio' || field.type == 'checkbox'">
        <label
          v-for="(option, key) in options(field.options)"
          :key="key"
          :class="'survey-'+field.type"
        >
          <input
            v-model="newValue"
            :type="field.type"
            :name="field.type == 'checkbox' ? (field.name + '_' + key) : field.name"
            :value="key"
          >
          <div/>
          <span>{{ option }}</span>
        </label>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [Array, String],
      default: null
    },
    field: {
      type: Object,
      default: {}
    }
  },

  data() {
    return {
      newValue: this.value
    };
  },

  methods: {
    options(value) {
      if (!Array.isArray(value)) {
        return value;
      }
      let options = {};
      for (let i in value) {
        let v = value[i];
        options[v] = v;
      }
      return options;
    }
  },

  mounted() {
    if (this.value === null) {
      this.newValue = this.field.type === "checkbox" ? [] : "";
    }
  },

  watch: {
    value() {
      if (!this.value) {
        this.newValue = this.field.type === "checkbox" ? [] : "";
      } else {
        this.newValue = this.value;
      }
    },

    newValue() {
      this.$emit("input", this.newValue);
      this.$emit("changed", this.newValue);
    }
  }
};
</script>
